import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationModalComponent } from "@app/shared/components";
import { ToolService } from "app/core/services/tool.service";
import { Subscription } from "rxjs";
import { Tool } from "@app/tool/model/tool.model";
import { Log } from "ng2-logger";
import { PermissionService } from "@app/authentication/services/permission.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { DocumentTreeModalComponent } from './components/document-tree-modal/document-tree-modal.component';
import { CacheService } from '@app/core/services/cache.service';
import { CacheType } from '@app/shared/models/enums/cachetype.enum';
import { CacheOptions } from '@app/shared/models/cacheOptions.model';

@Component({
    selector: 'app-tool-documentation',
    templateUrl: './tool-documentation.component.html',
    styleUrls: ['./tool-documentation.component.scss']
})
export class SpecificToolDocumentationComponent implements OnInit, OnDestroy {
    _logger = Log.create(SpecificToolDocumentationComponent.name);
    @ViewChild('cardinalityConfirmation', {static: true}) cardinalityConfirmationModal: ConfirmationModalComponent;
    @ViewChild('treeModal', {static: true}) treeModal: DocumentTreeModalComponent;
    isLoading = false;
    selectedTool: Tool;
    subscription: Subscription;

    selectedDocument: any;

    constructor(private permissionService: PermissionService,
                private toastr: ToastsManager,
                private translateService: TranslateService,
                private toolService: ToolService,
                private cacheService: CacheService) {
        this.subscribeToToolChanges();
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    getToolDocumentation(id: number) {
        this.isLoading = true;
        this._logger.info('getToolDocumentation:: Retrieving documentation for toolId', id);
        this.toolService.getDocumentationForTool(id)
            .subscribe(
                data => {
                    this._logger.info('getToolDocumentation:: API Returned data', data);
                    this.selectedTool.documents = data;
                    this.isLoading = false;
                },
                error => {
                    this._logger.error('getToolDocumentation:: API Returned error', error);
                    this.isLoading = false;
                }
            )
    }


    downloadFile(event) {
        this._logger.info('downloadFile::', event);
        this.toolService.downloadFile(event.fullPath);
    }


    openCardinalityChangeModal(event) {
        this.selectedDocument = event.data;
        this.cardinalityConfirmationModal.open();
    }

    updateDocumentCardinality() {
        this.isLoading = true;
        this.cardinalityConfirmationModal.close();

        this.selectedDocument.isMandatory = !this.selectedDocument.isMandatory;
        this.toolService.saveToolDocument(this.selectedTool.id, this.selectedDocument.type, this.selectedDocument).subscribe(data => {
                this._logger.info('createVersion:: API Returned data', data);
                this.toastr.success(this.translateService.instant('admin.tools.details.documentsPage.fileManager.toastr.success.update',
                    {name: this.selectedDocument.name}));

                this.toolService.announceToolUpdate(this.selectedTool);

                this.selectedDocument = null;
            },
            (error) => {
                this.isLoading = false;
            });
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_TOOLS') && this.selectedTool && !this.selectedTool.isDeleted;
    }

    editPath(event) {
        this.isLoading = true;
        this.selectedDocument = event.data;
        this._logger.info('pathEdit::', event);
        this._logger.info('pathEdit::', this.selectedDocument)

        this.toolService.getDocumentsLocationForTool(this.selectedTool.id, this.selectedDocument.type).subscribe((data) => {
            this.treeModal.open(data, this.selectedDocument.type);
            this.isLoading = false;
        });
    }

    private subscribeToToolChanges() {
        this._logger.info('subscribeToToolChanges:: Subscribing to toolsSelected$');
        this.subscription = this.toolService.toolSelectedAsObservable.subscribe(
            (tool) => {
                this.selectedTool = tool;
                if (this.selectedTool && this.selectedTool.id) {
                    this.getToolDocumentation(this.selectedTool.id);
                }
            },
            (error) => {
                this._logger.error('subscribeToToolChanges:: Subscriber error', error);
            }
        )
    }

    createDocumentLocations(event) {
        this.toolService.updateDocumentsLocationForTool(event.toolId, event.listOfPaths, event.type).subscribe((data) => {
                this._logger.info('createVersion:: API Returned data', data);
                this.toastr.success(this.translateService.instant('admin.tools.details.documentsPage.path-modal.toastr.success'));
                this.toolService.announceToolUpdate(this.selectedTool);
                this.treeModal.close()
            },
            (error) => {
                this.isLoading = false;
            });
    }

    refreshCache() {
        this._logger.info('refreshCache::', this.selectedTool);
        this.cacheService.clearCache(new CacheOptions({toolDetailsId: this.selectedTool.toolDetailsId}), CacheType.ToolDocumentLocations)
            .subscribe((data) => {
                this.toastr.success(this.translateService.instant('admin.tools.details.documentsPage.refreshButtonTostrSuccess'));
                this.toolService.announceToolUpdate(this.selectedTool);
            });
    }
}
